import request from '@/utils/request'


/**
 * 2023年2月13日
 * 获取账户或授信额度
 * */
export function getEnterprisesInfo() {
    let url = 'procurement/system/front/enterprises/info';

    return request({
        url: url,
    })
}

/**
 * 2023年2月7日
 * 添加新品收集
 * */
export function addNewGather(data) {
    let url = 'procurement/system/front/sms-new-commoditys';

    return request({
        url: url,
        method: "POST",
        data: data
    })
}

/**
 * 2023年2月8日
 * 发送验证码
 * */
export function sendVerifyCode() {
    let url = 'procurement/system/front/enterprises/update-password';

    return request({
        url: url,
        method: "GET",
    })
}

/**
 * 2023年2月8日
 * 修改密码
 * */
export function updatePasswd(params) {
    let url = 'procurement/system/front/enterprises/update-password';

    return request({
        url: url,
        method: "PUT",
        params: params
    })
}
/**
 * 2025年1月3日
 * 导入比价-下载
 * */
export function commodityParity(params) {
    let url = 'procurement/system/front/product/commodityParity';

    return request({
        url: url,
        method: "POST",
        data: params
    })
}

/**
 * 2025年1月3日
 * 导入比价-下载列表
 * */
export function getDownloadList(params) {
    let url = 'procurement/system/front/file-export-ftps/list';

    return request({
        url: url,
        method: "GET"
    })
}
